var landia = landia || {};
( function () {
    'use strict';
    jQuery( function () {
        landia.splideSlider.init();
        landia.dealersearch.init();
        landia.printPage.init();
        landia.imageModalPreview.init();
    } );
    
    landia.printPage = {
      init: function () {
          jQuery( '.js-landia-print-page' ).on( 'click', function () {
              window.print();
          });
      }  
    };


    landia.imageModalPreview = {
        init: function () {
            jQuery( '.js-landia-image-preview' ).on( 'click', function ( e ) {
                console.log( 'image preview' );
                e.preventDefault();
                var strImageUrl = jQuery( this ).data( 'image-url' );
                console.log( strImageUrl );
                jQuery( '.js-landia-image-preview-modal' ).find( 'img' ).attr( 'src', strImageUrl );
                jQuery( '.js-landia-image-preview-modal' ).modal( 'show' );
                
            });
        }
    };    
    
    landia.splideSlider = {
        init: function () {
            if( jQuery( '.js-landia-case-slider' ).length > 0 ) {
                landia.splideSlider.build();   
            }
        },
        build: function () {
            new Splide( '.js-landia-case-slider', {
                classes: {
                    // Add classes for arrows.
                    arrows: 'splide__arrows landia-case-slider-arrows',
                    arrow : 'splide__arrow landia-case-slider-arrow',
                    prev  : 'splide__arrow--prev landia-case-slider-prev',
                    next  : 'splide__arrow--next landia-case-slider-next',

                    // Add classes for pagination.
                    pagination: 'splide__pagination landia-case-slider-pagination', // container
                    page      : 'splide__pagination__page landia-case-slider-page', // each button
                },
                autoplay: false,
                pagination: false,
                rewind: true,
                cover  : true,
                width: '100%',
                autoHeight: true,
                perPage: 3,
                gap: '1em',
                breakpoints: {
                    1430: {
                        perPage: 2,
                    },
                    840: {
                        perPage: 1,
                    },
                }
            } ).mount();            
        }
    };
    landia.dealersearch = {
        options: {
            url: '/system/data/dealersearch', 
            lang: jQuery( 'html' ).attr( 'lang' )
        },
        
        init: function () {
            if ( jQuery( '#js-e-dealersearch-container' ).length === 1 ) {
                e4.require.js( e4.settings.require.handlebars, function () {
                    e4.handlebars.registerHelpers( 'compare' );
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-dealersearch' );
                    landia.dealersearch.bindEvents();
                    landia.dealersearch.get();
                } );
            }
        },
        bindEvents: function () {
            jQuery( '#js-e-dealersearch-container' ).on( 'change', '.js-landia-country-selector', function () {
                jQuery( '.js-landia-country' ).hide();
                if ( jQuery( this ).val() === '' ) {
                    jQuery( '.js-landia-country' ).fadeIn( 'slow' );
                }
                else {
                    jQuery( '.js-landia-country[data-contry-code="' + jQuery( this ).val() + '"]' ).fadeIn( 'slow' );
                }
            } );
        },
        get: function () {
            jQuery.ajax( {
                url: landia.dealersearch.options.url,
                type: 'GET',
                dataType: 'json'
            } )
                .done( function ( data ) {
                    landia.dealersearch.build( data );
                    console.log( data );
                } )
                .fail( function ( error ) {
                    console.error( error );
                    console.log( data );
                } );

        },
        build: function ( data ) { 
            var jContainer = jQuery( '#js-e-dealersearch-container' );
            jQuery.each( data.selectList, function ( index, country ) {
                if ( country.countryCode === jContainer.data( 'default-country' ) ) {
                    country.isSelected = true;
                }
            } );
            jContainer.html( e4.handlebars.tmpl.dealersearch( data ) );
            if ( jQuery( '.js-landia-frontpage' ).length && landia.dealersearch.options.lang === 'da' ) {
                jContainer.find( '.js-landia-country-selector' ).val( 'int' ).trigger( 'change' );
            }
            else {
                jContainer.find( '.js-landia-country-selector' ).val( jContainer.data( 'default-country' ) ).trigger( 'change' );
            }

        }
    };    
}()); 